import videojs from 'video.js';
import './seekbar-custom-component.js';
import './thumbnail-seeking-component.js';
import SRGStreamType from '../../utils/SRGStreamType.js';
import * as PlayerEvents from '../../utils/PlayerEvents.js';
import * as Events from '../../utils/Events.js';

const VJSProgressControl = videojs.getComponent('ProgressControl');

/**
 * LetterBoxWeb component improved the original ProgressControl,
 * with show / hide logic and using specific childrens.
 * @ignore
 */
class ProgressControl extends VJSProgressControl {
  constructor(player, options) {
    const opt = videojs.mergeOptions({
      children: [
        'SeekBarCustomComponent',
        'ThumbnailSeeking',
      ],
    }, options);

    super(player, opt);

    this.initListener();
  }

  initListener() {
    this.player().on(PlayerEvents.LOAD_START, () => {
      if (SRGStreamType.isLive(this.player().currentSource().streamType)) {
        this.hide();
      } else {
        this.show();
      }
    });
  }

  handleMouseMove(event) {
    const seekBar = this.getChild('SeekBarCustomComponent');

    if (seekBar) {
      const mouseTimeDisplay = seekBar.getChild('mouseTimeDisplay');
      const seekBarEl = seekBar.el();
      const seekBarRect = videojs.dom.getBoundingClientRect(seekBarEl);
      let seekBarPoint = videojs.dom.getPointerPosition(seekBarEl, event).x;

      if (seekBarPoint > 1) {
        seekBarPoint = 1;
      } else if (seekBarPoint < 0) {
        seekBarPoint = 0;
      }

      if (mouseTimeDisplay) {
        mouseTimeDisplay.update(seekBarRect, seekBarPoint);
      }
    }
  }

  handleMouseSeek(event) {
    const seekBar = this.getChild('SeekBarCustomComponent');

    if (seekBar) {
      seekBar.handleMouseMove(event);
    }
  }

  handleMouseDown(event) {
    const doc = this.el().ownerDocument;
    const seekBar = this.getChild('SeekBarCustomComponent');

    if (seekBar) {
      seekBar.handleMouseDown(event);
    }

    this.on(doc, Events.MOUSE_MOVE, this.throttledHandleMouseSeek);
    this.on(doc, Events.TOUCH_MOVE, this.throttledHandleMouseSeek);
    this.on(doc, Events.MOUSE_UP, this.handleMouseUp);
    this.on(doc, Events.TOUCH_END, this.handleMouseUp);
  }

  handleMouseUp(event) {
    const doc = this.el().ownerDocument;
    const seekBar = this.getChild('SeekBarCustomComponent');

    if (seekBar) {
      seekBar.handleMouseUp(event);
    }

    this.off(doc, Events.MOUSE_MOVE, this.throttledHandleMouseSeek);
    this.off(doc, Events.TOUCH_MOVE, this.throttledHandleMouseSeek);
    this.off(doc, Events.MOUSE_UP, this.handleMouseUp);
    this.off(doc, Events.TOUCH_END, this.handleMouseUp);
  }
}

videojs.registerComponent('ProgressControl', ProgressControl);
export default ProgressControl;
